var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasFeatures)?_c('vm-source',{attrs:{"name":"trilhaSource","type":"geojson","options":{ data: this.geoJSON }}},[_c('vm-layer',{attrs:{"name":"trilha-name","type":"symbol","layout":{
          'symbol-placement': 'line-center',
          'icon-image': ['get', 'tipo'],
          'icon-anchor': 'bottom',
          'icon-allow-overlap': false,
          'text-field': '{nome}',
          'text-anchor': 'bottom',
          'text-line-height': 1,
          'text-optional': true,
          'text-offset': {
            base: 1,
            stops: [[10, [0, 2]]]
          },
          'text-padding': 0,
          'text-size': {
            base: 1,
            stops: [
              [10, 12],
              [14, 12]
            ]
          },
          'icon-size': {
            base: 1,
            stops: [
              [11, 0.5],
              [18, 1]
            ]
          }
        },"paint":{
          'text-color': ['get', 'color'],
          'text-halo-color': 'black',
          'text-halo-width': 0.4,
          'text-halo-blur': 0.2,
          'text-opacity': {
            base: 1,
            stops: [
              [6, 0],
              [7, 1],
              [15, 1]
            ]
          },
          'icon-opacity': {
            base: 1,
            stops: [
              [14, 1],
              [15, 1]
            ]
          }
        }},on:{"featureselect":_vm.onClick}}),_c('vm-layer',{attrs:{"type":"line","name":"trilha-line-color","layout":{
          'line-join': 'round',
          'line-cap': 'round'
        },"paint":{
          'line-dasharray': {
            base: 1,
            stops: [
              [11, [1, 1]],
              [15, [1, 1]]
            ]
          },
          'line-color': ['get', 'color'],
          'line-width': {
            base: 1,
            stops: [
              [4, 1],
              [6, 3],
              [15, 4]
            ]
          },
          'line-opacity': {
            base: 1,
            stops: [
              [5, 0],
              [6, 1]
            ]
          }
        }}}),_c('vm-layer',{attrs:{"type":"line","name":"trilha-selected","filter":['==', ['get', 'id'], _vm.currentTrilhaID],"paint":{
          'line-color': 'yellow',

          'line-width': {
            base: 1,
            stops: [
              [4, 3],
              [15, 6]
            ]
          },
          'line-opacity': {
            base: 1,
            stops: [
              [10, 1],
              [14, 1]
            ]
          }
        },"layout":{
          'line-join': 'round',
          'line-cap': 'round'
        }}}),_c('vm-layer',{attrs:{"name":"trilha-name","type":"symbol","layout":{
          'symbol-placement': 'line-center',
          'icon-image': ['get', 'tipo'],
          'icon-anchor': 'bottom',
          'icon-allow-overlap': false,
          'text-field': '{nome}',
          'text-anchor': 'bottom',
          'text-line-height': 1,
          'text-optional': true,
          'text-offset': {
            base: 1,
            stops: [[10, [0, 2]]]
          },
          'text-padding': 0,
          'text-size': {
            base: 1,
            stops: [
              [10, 12],
              [14, 12]
            ]
          },
          'icon-size': {
            base: 1,
            stops: [
              [11, 0.5],
              [18, 1]
            ]
          }
        },"paint":{
          'text-color': 'white',
          'text-halo-color': 'white',
          'text-halo-width': 0.4,
          'text-halo-blur': 0.2,
          'text-opacity': {
            base: 1,
            stops: [
              [6, 0],
              [7, 1],
              [15, 1]
            ]
          },
          'icon-opacity': {
            base: 1,
            stops: [
              [14, 1],
              [15, 1]
            ]
          }
        }}}),_c('vm-layer',{attrs:{"type":"line","name":"trilha-event-placeholder","paint":{
          'line-color': ['get', 'color'],
          'line-width': {
            base: 1,
            stops: [
              [4, 3],
              [6, 9],
              [15, 10]
            ]
          },
          'line-opacity': 0
        }},on:{"featureselect":_vm.onClick},scopedSlots:_vm._u([{key:"popupHover",fn:function(slotProps){return [_c('vm-popup',{attrs:{"color":_vm.$get(slotProps, 'features[0].properties.color')}},[_c('small',[_c('i',{staticClass:"vtl vtl-percurso"}),_vm._v(" TRILHA")]),_c('div',[_c('b',[_vm._v(_vm._s(_vm.$get(slotProps, "features[0].properties.nome")))])]),_c('div',[_vm._v(" Distância: "),_c('b',[_vm._v(_vm._s(_vm.$get(slotProps, "features[0].properties.comprimento",0))+" km")])])])]}}],null,false,2041519367)})],1):_vm._e(),_c('vm-image',{attrs:{"name":"trilha-inicio"}},[_c('svg',{attrs:{"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","width":"44","height":"44","viewBox":"0 0 44 44"}},[_c('title',[_vm._v("trilha-inicio")]),_c('rect',{attrs:{"x":"14.86","y":"6.09","width":"2.63","height":"30.27"}}),_c('polygon',{staticStyle:{"fill":"#00d1b2"},attrs:{"points":"38.31 17.73 18.96 29.23 18.96 6.23 38.31 17.73 38.31 17.73"}}),_c('polygon',{staticStyle:{"fill":"#fff"},attrs:{"points":"19.46 41.66 16.39 36.48 22.54 36.48 19.46 41.66 19.46 41.66"}})])]),_c('vm-image',{attrs:{"name":"trilha-fim"}},[_c('svg',{attrs:{"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44","width":"44","height":"44"}},[_c('title',[_vm._v("trilha-fim")]),_c('rect',{attrs:{"x":"14.86","y":"6.59","width":"2.63","height":"30.27"}}),_c('polygon',{staticStyle:{"fill":"#d1479c"},attrs:{"points":"38.31 18.23 18.96 29.73 18.96 6.73 38.31 18.23 38.31 18.23"}}),_c('polygon',{staticStyle:{"fill":"#fff"},attrs:{"points":"19.46 42.16 16.39 36.98 22.54 36.98 19.46 42.16 19.46 42.16"}})])]),(false && _vm.startEndGeoJSON.features.length > 0)?_c('vm-layer',{attrs:{"name":"trilha-start-end-points","source":{
        type: 'geojson',
        data: _vm.startEndGeoJSON
      },"type":"symbol","minzoom":4,"layout":{
        'icon-image': ['get', 'tipo'],
        'icon-anchor': 'bottom',
        'icon-allow-overlap': true,
        'text-field': '{nome}',
        'text-anchor': 'top',
        'text-line-height': 1,
        'text-optional': true,
        'text-offset': {
          base: 1,
          stops: [[10, [0, 1]]]
        },
        'text-padding': 0,
        'text-size': {
          base: 1,
          stops: [
            [10, 12],
            [14, 12]
          ]
        },
        'icon-size': {
          base: 1,
          stops: [
            [11, 1],
            [18, 1]
          ]
        }
      },"paint":{
        'text-color': 'white',
        'text-halo-color': 'white',
        'text-halo-width': 0.4,
        'text-halo-blur': 0.2,
        'text-opacity': {
          base: 1,
          stops: [
            [14, 0],
            [15, 1]
          ]
        },
        'icon-opacity': {
          base: 1,
          stops: [
            [14, 1],
            [15, 1]
          ]
        }
      }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }